import { useEffect, useState } from "react";
import { Path } from "../utilities/constants";
import "../styles/facebook-callback.scss";

export default function FacebookCallback() {
  const [targetUrl, setTargetUrl] = useState(Path.AccountGeneral);
  const [showManualContinue, setShowManualContinue] = useState(false);

  useEffect(() => {
    const queryString = window.location.search;
    const hash = window.location.hash;
    const targetUrl = `${Path.AccountGeneral}${queryString}${hash}`;
    setTargetUrl(targetUrl);

    const redirectTimer = setTimeout(() => {
      window.location.replace(targetUrl);
    }, 900);

    const manualContinueTimer = setTimeout(() => {
      setShowManualContinue(true);
    }, 3000);

    return () => {
      clearTimeout(redirectTimer);
      clearTimeout(manualContinueTimer);
    };
  }, []);

  return (
    <div className="facebook-callback">
      <div className="facebook-callback__card" role="status" aria-live="polite">
        <div className="facebook-callback__brand-row">
          <span className="facebook-callback__brand-icon" aria-hidden="true">
            <i className="fab fa-facebook-f" />
          </span>
          <span className="facebook-callback__brand-text">
            Facebook Connection
          </span>
        </div>

        <h1 className="facebook-callback__title">Finalizing your sign in</h1>
        <p className="facebook-callback__subtitle">
          We are securely processing your Facebook authentication and returning
          you to Account Settings.
        </p>

        <div className="facebook-callback__progress">
          <span className="facebook-callback__spinner" aria-hidden="true" />
          <span className="facebook-callback__progress-text">
            Redirecting now...
          </span>
        </div>

        <div className="facebook-callback__steps" aria-hidden="true">
          <div className="facebook-callback__step facebook-callback__step--done">
            <i className="fas fa-check-circle" />
            <span>Sign-in response received</span>
          </div>
          <div className="facebook-callback__step facebook-callback__step--active">
            <i className="fas fa-circle-notch" />
            <span>Applying account connection</span>
          </div>
        </div>

        {showManualContinue && (
          <div className="facebook-callback__manual">
            <p className="facebook-callback__manual-text">
              Still here? Continue to complete setup.
            </p>
            <button
              type="button"
              className="btn facebook-callback__manual-btn"
              onClick={() => window.location.assign(targetUrl)}
              aria-label="Continue to Account Settings"
            >
              Continue to Account Settings
            </button>
          </div>
        )}
      </div>
    </div>
  );
}
